module.exports = __webpack_public_path__ + "img/daphne-logo.c9099edc.jpg";